import { render, staticRenderFns } from "./SpotlightSmall.vue?vue&type=template&id=38518a86&scoped=true"
import script from "./SpotlightSmall.vue?vue&type=script&lang=js"
export * from "./SpotlightSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38518a86",
  null
  
)

export default component.exports